import { Box, Text, SimpleGrid, VStack, Divider, Image } from "@chakra-ui/react";
import background from "../assets/bg.jpg";
import Menubar from "../components/Menubar";
import { ACCENT_1_COLOR, PRIMARY_COLOR } from "../constants/color"; // Memastikan warna tema terimport
import { useTranslation } from "react-i18next";
import gashukuImage from "../assets/gashuku2.jpg"
import taikaiImage from "../assets/taikai.jpg"
import { Helmet } from "react-helmet-async";

export default function OurActivities() {
  const {t} = useTranslation();

  return (
    <Box display={"flex"} minH={"100vh"} width={"100vw"} background={`transparent url(${background})`}>
      <Helmet>
        <title>{t("ourActivitiesTitle")}</title>
        <meta name="description" content={t("ourActivitiesDesc")} />
        <link rel="canonical" href="https://mugairyu-indonesia.com/our-activities" />
      </Helmet>
      <Box width={"100vw"}>
        <Menubar />
        
        {/* Konten Utama */}
        <Box width={"100vw"} px={{ base: "5vw", lg: "20vw" }} pt="20px" pb="40px" display={"flex"} flexDir={"column"} textAlign={"left"}>
          
          {/* Header Halaman */}
          <Box mb={"32px"}>
            <Text textColor={ACCENT_1_COLOR} fontSize={"30px"} className="cormorant-garamond-bold">
              {t("ourActivities")}
            </Text>
            <Text textColor={"#765946"} fontSize={"20px"} className="yuji-syuku-regular" mt="1">
              活動内容
            </Text>
          </Box>

          <VStack spacing="40px" align="stretch">
            
            {/* 1. SECTION TAIKAI */}
            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={{ base: "20px", md: "40px" }} alignItems="center">
              <VStack align="flex-start" spacing="2">
                <Box>
                  <Text fontSize="22px" color={PRIMARY_COLOR} className="cormorant-garamond-bold" fontWeight="bold">
                    {t("annualTaikai")}
                  </Text>
                  <Text fontSize="15px" color={ACCENT_1_COLOR} className="yuji-syuku-regular">
                    {t("annualTaikai2")}
                  </Text>
                </Box>
                <Text fontSize="15px" lineHeight="1.7" textAlign="justify">
                  {t("annualTaikaiDesc2")}
                </Text>
              </VStack>

              {/* Placeholder Gambar Taikai */}
              <Box
                h="280px"
                bg="rgba(255, 255, 255, 0.03)"
                backdropFilter="blur(5px)"
                border="1px solid rgba(255, 255, 255, 0.08)"
                borderRadius="2px"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <Image
                  src={taikaiImage}
                  alt={"taikai"}
                  height={"280px"}
                />
              </Box>
            </SimpleGrid>

            {/* Garis Pembatas */}
            <Divider borderColor="rgba(255, 255, 255, 0.08)" />

            {/* 2. SECTION GASHUKU */}
            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={{ base: "20px", md: "40px" }} alignItems="center">
              {/* Gambar diposisikan di kiri pada desktop (order 2 di mobile, 1 di desktop) */}
              <Box
                h="280px"
                bg="rgba(255, 255, 255, 0.03)"
                backdropFilter="blur(5px)"
                border="1px solid rgba(255, 255, 255, 0.08)"
                borderRadius="2px"
                display="flex"
                alignItems="center"
                justifyContent="center"
                order={{ base: 2, md: 1 }}
              >
                <Image
                  src={gashukuImage}
                  alt={"gashuku"}
                  height={"280px"}
                />
              </Box>

              <VStack align="flex-start" spacing="2" order={{ base: 1, md: 2 }}>
                <Box>
                  <Text fontSize="22px" color={PRIMARY_COLOR} className="cormorant-garamond-bold" fontWeight="bold">
                    {t("gashuku")}
                  </Text>
                  <Text fontSize="15px" color={ACCENT_1_COLOR} className="yuji-syuku-regular">
                    {t("gashuku2")}
                  </Text>
                </Box>
                <Text fontSize="15px" lineHeight="1.7" textAlign="justify">
                  {t("gashukuDesc")}
                </Text>
                <Text fontSize="15px" lineHeight="1.7" textAlign="justify">
                  {t("gashukuDesc2")}
                </Text>
              </VStack>
            </SimpleGrid>

          </VStack>

        </Box>
      </Box>
    </Box>
  );
}